import { render, staticRenderFns } from "./CountryInfo.vue?vue&type=template&id=5bf333aa&scoped=true"
import script from "./CountryInfo.vue?vue&type=script&lang=js"
export * from "./CountryInfo.vue?vue&type=script&lang=js"
import style0 from "./CountryInfo.vue?vue&type=style&index=0&id=5bf333aa&prod&lang=scss&scoped=true"
import style1 from "./CountryInfo.vue?vue&type=style&index=1&id=5bf333aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf333aa",
  null
  
)

export default component.exports